import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { isClothesItem, RewardType } from '~/shared';
import {
	setModalBuyInventoryItem,
	setModalBuyType,
	setModalBuyVisible,
	useLayoutDispatch,
} from '../../redux';
import { calcOldPrice } from '../CaseItem';
import { ShopItem } from '../ShopItem';
import { StyledContainer, StyledEmptyContainer } from './ShopClothes.styled';

const ShopClothes = () => {
	const dispatch = useLayoutDispatch();
	const inventoryShopItems = useObservable(rage.donate.getInventoryShopItems());

	const clothesItems = useMemo(
		() =>
			inventoryShopItems.filter((item) => {
				const rewardType = rage.inventoryDonate.getTypeById(item.donateItemId);
				return (
					rewardType === RewardType.ITEM && isClothesItem(item.donateItemId)
				);
			}),
		[inventoryShopItems],
	);

	const isEmpty = clothesItems.length === 0;

	if (isEmpty) {
		return (
			<StyledEmptyContainer>
				<Text>
					К сожалению,
					<br />
					доступной одежды нет
				</Text>
			</StyledEmptyContainer>
		);
	}

	return (
		<StyledContainer>
			{clothesItems.map((item) => {
				const imageId =
					rage.cases.getRewardImageId(item.donateItemId) ?? item.donateItemId;
				const name = rage.cases.getRewardNameById(item.donateItemId);

				return (
					<ShopItem
						type="clothes"
						id={imageId}
						name={name}
						price={item.price}
						oldPrice={calcOldPrice(item.price, item.discount ?? 0)}
						discount={item.discount ?? undefined}
						dateDiscountEnd={item.discountTimestampEnd ?? undefined}
						dateEnd={item.enabledTimestampEnd ?? undefined}
						key={item.donateItemId}
						onClick={() => {
							dispatch(
								setModalBuyInventoryItem({
									donateItemId: item.donateItemId,
									name,
									price: item.price,
									oldPrice: calcOldPrice(item.price, item.discount ?? 0),
									imageId,
									type: 'clothes',
									rarity: item.rarity ?? null,
									discount: item.discount ?? null,
									discountTimestampEnd: item.discountTimestampEnd ?? null,
								}),
							);
							dispatch(setModalBuyType('clothes'));
							dispatch(setModalBuyVisible(true));
						}}
					/>
				);
			})}
		</StyledContainer>
	);
};

export { ShopClothes };
